import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Drawer, Button, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { GlobalContext } from 'src/contexts/globalContext';
import { useStore } from 'src/stores';
import { reportsDisabledFor, isAppfolioFrom } from 'src/pages/ReportingPage/tabsFor';
import useStyles from './styles';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import { CreateEditPortfolioModal } from 'src/components/shared/CreateEditPortfolioModal';
import CreateAccountModal from 'src/pages/AdminPage/CreateAccountModal';
import { PALETTE_EVENT } from 'src/components/livy/LivyCommandPalette';
import { canUseLivy } from 'src/components/livy/access';
import { paletteShortcut } from 'src/lib/platformKeys';
export const PmSidebar = observer(() => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  const _useContext = useContext(GlobalContext),
    sidebarIsOpen = _useContext.sidebarIsOpen;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEnrollModal = _useState4[0],
    setShowEnrollModal = _useState4[1];
  let handleShowEnrollModal = val => {
    setShowEnrollModal(val);
  };
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCreatePortfolioModalOpen = _useState6[0],
    setIsCreatePortfolioModalOpen = _useState6[1];
  const handleShowCreatePortfolioModal = value => {
    setIsCreatePortfolioModalOpen(value);
    // setRenameModalProps(null);
  };
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isCreateAccountModalOpen = _useState8[0],
    setIsCreateAccountModalOpen = _useState8[1];
  const handleIsCreateAccountModalOpen = value => {
    setIsCreateAccountModalOpen(value);
  };
  const sidebarContent = /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContent, " ").concat(sidebarIsOpen ? '' : 'isClosed')
  }, (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin || !store.company.companyFeatureStore.isAppfolio) && /*#__PURE__*/React.createElement("div", {
    className: classes.nbmContentActions
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Add new') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    size: "small",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '63-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Add new"))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement("div", null, !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    onClick: () => {
      handleClose();
    },
    'custom-attribute': '64-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building-plus"
  }), t('portfolios_properties_page.add_new_property')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      setShowEnrollModal(!showEnrollModal);
      handleClose();
    },
    'custom-attribute': '65-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), "Enroll new resident")), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      setIsCreatePortfolioModalOpen(!showEnrollModal);
      handleClose();
    },
    'custom-attribute': '66-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "folder-house"
  }), "Add new portfolio"), (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      handleIsCreateAccountModalOpen(!isCreateAccountModalOpen);
      handleClose();
    },
    'custom-attribute': '67-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "portfolio-full"
  }), "Add new company")))), /*#__PURE__*/React.createElement("div", {
    className: classes.nbmContentList
  }, canUseLivy() && /*#__PURE__*/React.createElement("div", {
    className: classes.nbmContentItem
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Search') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => window.dispatchEvent(new Event(PALETTE_EVENT)),
    'custom-attribute': 'livy-search-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "search"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Search", /*#__PURE__*/React.createElement("kbd", null, paletteShortcut))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('active_dashboard') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Properties') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/active_dashboard'),
    'custom-attribute': '68-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Properties")))), store.account.featureFlagsStore.getIsBillsDashboardEnabled && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname === '/bills' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Bills') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/bills'),
    'custom-attribute': 'bills-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "ai-file-sparkle"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Bills")))), store.account.userProfile.isUserPmRegularOrHigher && !reportsDisabledFor(store.company.companyFeatureStore.disableReports, (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.disableReports, isAppfolioFrom(store.company.companyFeatureStore.isAppfolio, (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyFeatureSet) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.isAppfolio)) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('reporting') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Reports') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
    // No tab in the link: an AppFolio company has no Accounts Receivable tab, so the page
    // picks whichever tab that customer actually has.
    ,
    onClick: () => navigate('/reporting'),
    'custom-attribute': '69-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "statistics"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Reports")))), store.account.featureFlagsStore.getIsNewPaymentsAndSubscriptions && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('payments_and_subscriptions') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Payments') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/payments_and_subscriptions'),
    'custom-attribute': '73-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "credit-card"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Payments")))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('file_cabinet') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Files') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/file_cabinet?tab=manager_resources'),
    'custom-attribute': '69-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "folder-close"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Files")))), /*#__PURE__*/React.createElement("div", {
    className: classes.nbmContentItem
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Calculator') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    target: "_blank",
    variant: "actionButton",
    component: RouterLink,
    to: "https://pm.livable.com/calculator",
    'custom-attribute': '72-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "calculator"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Calculator'))))), (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(React.Fragment, null, canUseLivy() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname === '/livy' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Livy') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/livy'),
    'custom-attribute': 'livy-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "chat"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Livy")))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('/livy/kb') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Knowledge base') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/livy/kb'),
    'custom-attribute': 'livy-kb-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-text"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Knowledge"))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('admin') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Admin') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/admin'),
    'custom-attribute': '70-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "access-key"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Admin")))), store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('pro-pricing') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Pro Pricing') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/pro-pricing'),
    'custom-attribute': 'pro-pricing-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Pro Pricing")))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('appfolio') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Appfolio') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/appfolio'),
    'custom-attribute': '71-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "settings-type"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Appfolio")))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.nbmContentItem, " ").concat(window.location.pathname.includes('information_banners') ? 'active' : '')
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: !sidebarIsOpen ? t('Notifications') : '',
    placement: 'right',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/information_banners'),
    'custom-attribute': '72-pm-sidebar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "notification"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Notifications")))))), /*#__PURE__*/React.createElement(EnrollmentModal, {
    key: 'global-billing-module-enroll-modal',
    showCurrentEnrollModal: showEnrollModal,
    handleShowCurrentEnrollModal: handleShowEnrollModal,
    enablePortfolioSelect: store.homeDashboardStore.selectedPortfolioId === 'all',
    enablePropertySelect: store.homeDashboardStore.selectedPropertyId === 'all',
    trigger: null
  }), /*#__PURE__*/React.createElement(CreateEditPortfolioModal
  // triggerRefresh={triggerRefresh}
  , {
    showModal: isCreatePortfolioModalOpen,
    handleShowModal: handleShowCreatePortfolioModal,
    customTrigger: null
  }), (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(CreateAccountModal, {
    trigger: null,
    isOpen: isCreateAccountModalOpen,
    handleClose: () => setIsCreateAccountModalOpen(false)
  }));

  // One permanent drawer at every width: it sits in the app's flex row, so opening it pushes the
  // page instead of floating a modal over it.
  return /*#__PURE__*/React.createElement(Drawer, {
    className: "".concat(classes.sidebarDrawer, " ").concat(sidebarIsOpen ? classes.isOpen : classes.isClosed),
    variant: "permanent"
  }, sidebarContent);
});